import { useState, useEffect } from 'react'
import { getModuleProgress, getWeekProgress, upsertWeekProgress, completeWeek } from '../supabase/api'

export function useModuleProgress(pairId) {
  const [progress, setProgress] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!pairId) { setLoading(false); return }
    fetchProgress()
  }, [pairId])

  const fetchProgress = async () => {
    try {
      setLoading(true)
      const data = await getModuleProgress(pairId)
      setProgress(data)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const saveWeek = async (weekNumber, updates) => {
    const data = await upsertWeekProgress(pairId, weekNumber, updates)
    setProgress(prev => {
      const exists = prev.find(p => p.week_number === weekNumber)
      return exists
        ? prev.map(p => p.week_number === weekNumber ? data : p)
        : [...prev, data]
    })
    return data
  }

  const markComplete = async (weekNumber) => {
    const data = await completeWeek(pairId, weekNumber)
    setProgress(prev => {
      const exists = prev.find(p => p.week_number === weekNumber)
      return exists
        ? prev.map(p => p.week_number === weekNumber ? data : p)
        : [...prev, data]
    })
    return data
  }

  const getWeekStatus = (weekNumber) => {
    const week = progress.find(p => p.week_number === weekNumber)
    return week?.status || 'not_started'
  }

  const completedCount = progress.filter(p => p.status === 'completed').length

  return { progress, loading, error, saveWeek, markComplete, getWeekStatus, completedCount, refetch: fetchProgress }
}